const ENVS = {
  prod: 'https://service.donsalomon.com/ds-service/public',
  stage: 'https://dservice.stagecr.com/ds-service/public',
  local: 'http://localhost:8000',
}

const ENV = ENVS.prod

export { ENV }
